<template>
  <div class="container p-relative" :style="{ padding: blockPadding }">
    <v-link
      is-attachment
      :with-access-checks="pageId && !unlock"
      :page-id="pageId"
      :force-lock="isBoolean(unlock) ? !unlock : false"
      :to="isBuilderContext() ? null : attachment.url"
      :class="[
        'attachment p-0 v-button --block --ghost',
        { '--raised': isRaised }
      ]"
    >
      <template v-slot="{ isLocked, isLoadingAccess, availableAfter }">
        <div
          v-if="isPresent(image)"
          class="attachment__background"
          :style="{
            minHeight: imageHeight,
            minHeight: `calc(${imageHeight} + env(safe-area-inset-top))`,
            backgroundImage: `url(${getImageUrl(image)})`
          }"
        ></div>

        <div class="attachment__file d-flex align-items-center">
          <h3 class="attachment__title">{{ attachment.name }}</h3>
          <div class="attachment__icon d-flex align-items-center">
            <template v-if="isLocked || isLoadingAccess">
              <access-lock
                :is-loading="isLoadingAccess"
                :available-after="availableAfter"
              />
            </template>
            <template v-else>
              <v-icon icon="attach_file" />
            </template>
          </div>
        </div>
      </template>
    </v-link>
  </div>
</template>

<script>
import {
  isPresent,
  getImageUrl,
  isBuilderContext,
  isBoolean
} from "@/lib/utils"
import { BLOCK_DEFAULT_HEIGHT_RATIO } from "@/lib/stream-utils"

import { withRatio, toPadding, BLOCK_BASE_HEIGHT } from "@shared/block-ratio"
import enumValidator from "@/lib/validators/enum-validator"

export default {
  components: {
    AccessLock: () => import("@/components/AccessLock")
  },

  props: {
    image: { type: Object, default: () => ({}) },
    attachment: { type: Object, default: () => ({}) },
    pageId: { type: Number, default: null },
    unlock: { type: Boolean, default: null },
    heightRatio: {
      type: Number,
      default: BLOCK_DEFAULT_HEIGHT_RATIO
    },
    spaceXRatio: {
      type: Number,
      default: 0
    },
    spaceTopRatio: {
      type: Number,
      default: 0
    },
    spaceBottomRatio: {
      type: Number,
      default: 0
    },
    cardStyle: {
      type: String,
      default: "raised",
      validator: enumValidator(["flat", "raised"])
    }
  },

  computed: {
    imageHeight() {
      return withRatio(BLOCK_BASE_HEIGHT, this.heightRatio)
    },

    blockPadding() {
      return toPadding(
        this.spaceTopRatio,
        this.spaceXRatio,
        this.spaceBottomRatio
      )
    },

    isRaised() {
      return this.cardStyle === "raised"
    }
  },

  methods: {
    getImageUrl,
    withRatio,
    isPresent,
    isBuilderContext,
    isBoolean
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.attachment {
  background: $color-ui--white;
  border-radius: var(--border-radius);
  overflow: hidden;
  &.--raised {
    box-shadow: var(--card-shadow);
  }
}

.attachment__background {
  width: 100%;
  transition: transform 0.1s linear;

  background-size: cover;
  background-position: center;
}

.attachment__file {
  padding: $size--3;
  width: 100%;
  background-color: $color-ui--white;
}

.attachment__title {
  font-size: $size--4;
  line-height: 1.3rem;
  font-weight: $font-weight--semi-bold;
  margin: 0;
}

.attachment__type {
  margin: $size--1 0 0.125rem;
  font-size: 0.7rem;
  color: $color-ui--grey-50;
  line-height: 1;
}

.attachment__icon {
  font-size: $font-size--large;
  font-weight: $font-weight--bold;
  color: $color-ui--grey-50;
  margin-left: auto;

  .access-lock {
    position: relative;
    top: unset;
    right: unset;
    margin-top: 0;
  }

  .v-icon {
    padding: $size--1 $size--2;
  }
}
</style>
